/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Section_SubtitleInputs */

const es_user_profile_api_keys_section_subtitle = /** @type {(inputs: User_Profile_Api_Keys_Section_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrá tu clave API personal para integraciones`)
};

const en_user_profile_api_keys_section_subtitle = /** @type {(inputs: User_Profile_Api_Keys_Section_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your personal API key for integrations`)
};

/**
* | output |
* | --- |
* | "Manage your personal API key for integrations" |
*
* @param {User_Profile_Api_Keys_Section_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_section_subtitle = /** @type {((inputs?: User_Profile_Api_Keys_Section_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Section_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_section_subtitle(inputs)
	return en_user_profile_api_keys_section_subtitle(inputs)
});
export { user_profile_api_keys_section_subtitle as "user.profile.api_keys.section.subtitle" }